import { createContext, useState } from 'react';

import OmeMeetEntryInvitationsData from './OmeMeetEntryInvitationsData';

export const OmeMeetEntryInvitationsStateContext = createContext();

const OmeMeetEntryInvitationsContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetEntryInvitationsData.INITIAL_STATE);

  return (
    <OmeMeetEntryInvitationsStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetEntryInvitationsStateContext.Provider>
  );
};

export default OmeMeetEntryInvitationsContextProvider;